// Shared "last selected coordination project" memory - a thin wrapper over
// helpers/projectSelection (one localStorage slot per environment + per user
// id), so every coordination page (Approval Queue, Checklists, landing, ...)
// opens on the project you were working on, and the choice survives
// logout/login on the same browser. A ?projectId= in the URL wins for that
// visit (and is remembered). Pass the loaded picker list so a remembered
// project that is no longer available is dropped (an empty list is treated
// as "not loaded yet" and never drops anything).
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { rememberProject, useRememberedProject } from "helpers/projectSelection";

function projectIdFromUrl() {
  try { return new URLSearchParams(window.location.search).get("projectId") || ""; } catch (e) { return ""; }
}

export default function useLastProject(projects) {
  const userInfoRedux = useSelector((s) => s.user?.userInfo);
  const userId = userInfoRedux?._id || userInfoRedux?.id;
  const fromUrl = projectIdFromUrl();
  const list = Array.isArray(projects) && projects.length ? projects : null;
  const [projectId, setRemembered] = useRememberedProject(userId, list, fromUrl);
  // Deep link: remember the URL's project on arrival too.
  useEffect(() => { if (fromUrl) rememberProject(userId, fromUrl); }, [fromUrl, userId]);
  const current = useRef(projectId);
  current.current = projectId;
  const setProjectId = (next) => {
    const v = typeof next === "function" ? next(current.current) : next;
    setRemembered(v || "");
  };
  return [projectId, setProjectId];
}
